module.exports = __webpack_public_path__ + "img/MassGIS 2001.017744e1.png";